var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCalendar2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.689,
    height: 24.601,
    viewBox: "0 0 25.689 24.601",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M55.012,10.846H34.98a1.13,1.13,0,0,0-1.13,1.131v3.759H56.143V11.977a1.131,1.131,0,0,0-1.131-1.131ZM39.586,13.108a.541.541,0,1,1,.541-.541.541.541,0,0,1-.541.541Zm10.963,0a.541.541,0,1,1,.541-.541.541.541,0,0,1-.541.541Z",
    transform: "translate(-32.152 -10.846)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M25.665,82.917l-1.71,8.916.7,9.272a1.173,1.173,0,0,1-1.17,1.261H2.206a1.174,1.174,0,0,1-1.17-1.261l.7-9.272L.025,82.917A1.361,1.361,0,0,1,1.361,81.3H24.328a1.361,1.361,0,0,1,1.337,1.617Z",
    transform: "translate(0 -77.765)",
    fill: "#3a5bbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M43.022,301.759H21.744a1.174,1.174,0,0,1-1.17-1.261l.7-9.272H43.5l.7,9.272a1.173,1.173,0,0,1-1.173,1.261Z",
    transform: "translate(-19.539 -277.158)",
    fill: "#518ef8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12684",
    "data-name": "Group 12684",
    transform: "translate(5.919 8.173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M124.458,185.116a3.251,3.251,0,0,0-6.493,0h1.085a2.167,2.167,0,1,1,2.164,2.074H120.2v1.082h1.01a2.076,2.076,0,1,1-2.164,2.078h-1.082a3.251,3.251,0,0,0,6.493,0,3.133,3.133,0,0,0-1.43-2.616,3.133,3.133,0,0,0,1.428-2.619Z",
    transform: "translate(-117.965 -181.547)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M289.289,175.988l.555.929,2.139-1.278v9.5h1.082V173.728Z",
    transform: "translate(-280.693 -173.728)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar2);
export default __webpack_public_path__ + "static/media/icon-calendar2.886d41839f2a22ef312a9c2924cdee9b.svg";
export { ForwardRef as ReactComponent };